import { CodedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useCachedAdminApi } from "../../api/admin-api/useCachedAdminApi";
import { DataHooksQueryKey } from "./DataHooksQueryKey";

export const useEmbeddedSubtitles = (): SprintQueryResult<CodedProperty[]> => {
    const { getEmbeddedSubtitles } = useCachedAdminApi();

    return useSprintQuery<CodedProperty[]>({
        queryKey: [DataHooksQueryKey.EmbeddedSubtitles],
        queryFn: async (): Promise<CodedProperty[]> => {
            const response = await getEmbeddedSubtitles();
            return response.items;
        }
    });
};
